/*
 * @Author: Latte
 * @Date: 2021-05-27 16:34:31
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-12 15:50:01
 * @FilePath: \Siui.Cloud.Medical.Web\src\store\index.js
 */
import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import app from "./modules/app";
import permission from "./modules/permission";
import settings from "./modules/settings";
import user from "./modules/user";
import newMsg from "./modules/newMsg"

Vue.use(Vuex);

const store = new Vuex.Store({
	modules: {
		app,
		permission,
		settings,
		user,
		newMsg
	},
	getters,
});

export default store;
